import React, { useState } from "react";
import { Button, Form, Alert, Spinner, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLogin } from "../../../hooks/useLogin";
import "./authForms.scss";

function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [pwdVisible, setPwdVisible] = useState(false);
  const [alert, setAlert] = useState(null);
  const { signin, isLoading } = useLogin();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    const response = await signin(username, password);
    if (response === "success") {
      navigate("/home-page");
    } else {
      setAlert({
        variant: "danger",
        message: response,
      });
    }
  };

  const togglePwd = () => setPwdVisible(!pwdVisible);
  return (
    <div className="login-container">
      <div className="login-div">
        {alert && (
          <Alert
            variant={alert.variant}
            onClose={() => setAlert(null)}
            dismissible
          >
            {alert.message}
          </Alert>
        )}
        {/* <p className="form-desc">Please sign in to see your dashboard.</p> */}
        <Form className="form-box">
          <Form.Group className="mb-3 box-form" controlId="formBasicEmail">
            <Form.Label className="text-above-box">Username</Form.Label>
            <Form.Control
              type="text"
              autoComplete="off"
              onChange={(e) => {
                setUsername(e.target.value);
              }}
              className="larg-input-box"
            />
          </Form.Group>
          <Form.Group className="mb-3 box-form" controlId="formBasicPassword">
            <Form.Label className="text-above-box">Password</Form.Label>
            <InputGroup bsPrefix="inputPassword">
              <Form.Control
                type={pwdVisible ? "text" : "password"}
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
                className="larg-input-box"
              />
              <Button className="togglePassword" onClick={togglePwd}>
                {pwdVisible ? <FaEye /> : <FaEyeSlash />}
              </Button>
            </InputGroup>
            {/* <Form.Text className="form-text mt-2">
              Please do not share your account details with any third parties.
            </Form.Text> */}
          </Form.Group>
          <h6 className="form-forgotPass">
            Forgot Password? Reset it{" "}
            <Link to="/forgot-pass" className="link-to">
              here
            </Link>
            .
          </h6>
          {isLoading ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <div className="d-grid gap-2">
              <Button
                variant="btn btn-primary login-buttomn"
                type="submit"
                onClick={handleLogin}
              >
                Login
              </Button>
            </div>
          )}
          <h6 className="form-register-link">
            You don't have an account? Please{" "}
            <Link to="/register" className="link-to">
              register
            </Link>
            .
          </h6>
        </Form>
      </div>
    </div>
  );
}

export default LoginForm;
